import { render, staticRenderFns } from "./charpter-wrap.vue?vue&type=template&id=236eaabe&scoped=true&"
import script from "./charpter-wrap.vue?vue&type=script&lang=js&"
export * from "./charpter-wrap.vue?vue&type=script&lang=js&"
import style0 from "./charpter-wrap.vue?vue&type=style&index=0&id=236eaabe&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236eaabe",
  null
  
)

export default component.exports